import { COLORS } from "common/constants/color.contants";
import styled from "styled-components";

export const BeigeContainer = styled.div`
  width: 100%;
  height: calc(100% - 75px);
  background-color: ${COLORS.porcelain};
`;
